export default __webpack_public_path__ + "e8b98f0bd30272feaf7a4176c146485b.png";